import React from "react";
import Icon from "./Icon";

function ProfileMenuItem({ item }) {
  const klass = 'profile-menu__item' + (item.danger ? ' profile-menu__item--danger' : '');
  const inner = (
    <>
      <Icon family="solid" name={item.icon} />
      <span>{item.label}</span>
    </>
  );
  return (
    <li role="none">
      {item.kind === 'link' ? (
        <a href={item.href} className={klass} role="menuitem">{inner}</a>
      ) : (
        <button
          type="button"
          className={klass}
          role="menuitem"
          onClick={item.onClick}
          disabled={item.disabled}
        >
          {inner}
        </button>
      )}
    </li>
  );
}

function ProfileMenu({ items }) {
  return (
    <details className="profile-menu">
      <summary className="profile-menu__trigger" aria-label="Меню">
        <Icon family="solid" name="fa-ellipsis-vertical" />
      </summary>
      <ul className="profile-menu__list" role="menu">
        {items.map((item) => (
          <ProfileMenuItem key={item.id} item={item} />
        ))}
      </ul>
    </details>
  );
}

export default ProfileMenu;
